import React from "react";
import { Link } from "react-router-dom";

const ServiceOne = () => {
  return (
    <>
      {/* Service area start */}
      <section className="service__area pb-150">
        <div className="container">
          <div className="row">
            <div className="col-xxl-7 col-xl-7 col-xl-7 col-md-7">
              <div className="service__title-wrap" data-aos="fade-up">
                <h2 className="sec-subtitle">
                  best service <span>best service</span>
                </h2>
                <h3 className="sec-title">
                  Innovative solutions for <br /> a digital world
                </h3>
              </div>
            </div>
            <div className="col-xxl-5 col-xl-5 col-xl-5 col-md-5">
              <div
                className="service__text"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <p>
                  Experience the difference with kraft64.com. Our commitment to excellence is reflected in our comprehensive services that cover a wide range of digital needs.
                </p>
              </div>
            </div>
          </div>
          <div className="row pt-4">
            <div className="col-xxl-4 col-xl-4 col-xl-4 col-md-4">
              <div className="service__item" data-aos="fade-up">
                <div className="icon">
                  <img src="assets/imgs/icon/s3.png" alt="Service Icon" />
                </div>
                <div className="service__content">
                  <Link to="/services">
                    <div className="service__title">Pixel Perfect Design</div>
                  </Link>
                  <p>
                  Elevate your online presence with captivating designs that grab attention and keep your audience engaged.
                  </p>
                  <Link className="db-btn-arrow" to="/services">
                    Read More <i className="fa-solid fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-xl-4 col-md-4">
              <div
                className="service__item"
                data-aos="fade-up"
                data-aos-delay={500}
              >
                <div className="icon">
                  <img src="assets/imgs/icon/s1.png" alt="Service Icon" />
                </div>
                <div className="service__content">
                  <Link to="/services">
                    <div className="service__title">
                    Social Media Mastery
                    </div>
                  </Link>
                  <p>
                  Unlock the potential of your brand on social platforms with our expert social media management.
                  </p>
                  <Link className="db-btn-arrow" to="/services">
                    Read More <i className="fa-solid fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xxl-4 col-xl-4 col-xl-4 col-md-4">
              <div
                className="service__item"
                data-aos="fade-up"
                data-aos-delay={1000}
              >
                <div className="icon">
                  <img src="assets/imgs/icon/s2.png" alt="Service Icon" />
                </div>
                <div className="service__content">
                  <Link to="/services">
                    <div className="service__title">Innovative Web Development</div>
                  </Link>
                  <p>
                  Immerse your audience in visually stunning and functional websites crafted by our skilled developers.
                  </p>
                  <Link className="db-btn-arrow" to="/services">
                    Read More <i className="fa-solid fa-arrow-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Service area end */}
    </>
  );
};

export default ServiceOne;
